import { render, staticRenderFns } from "./MergePatientDropdownItem.vue?vue&type=template&id=20b1c9b1&scoped=true&lang=pug&"
import script from "./MergePatientDropdownItem.vue?vue&type=script&lang=js&"
export * from "./MergePatientDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1c9b1",
  null
  
)

export default component.exports